export default __webpack_public_path__ + "static/media/Sofia-Pro-Regular.d5878d9c.otf";